import React from "react"
import * as classNames from "./ArticleLeftRightSection.module.scss"
import Section from "../../../../core/layout/main/section/Section"
import { articleUrl } from "../../../../../utils/routeLib"
import ArticleLeftRightBlock from "../../blocks/article-left-right/ArticleLeftRightBlock"

function ArticleLeftRightSection({ title, article, isAlignLeft }) {
  return (
    <Section
      container
      className={"pbl-8"}
    >
      <h2 className={classNames.title}>{title}</h2>
      <ArticleLeftRightBlock
        url={articleUrl(article)}
        article={article}
        isAlignLeft={isAlignLeft}
      />
    </Section>
  )
}
export const name = "ArticleLeftRightSection"

export const init = (componentData, pageContext) => {
  return (
    <ArticleLeftRightSection
      key={componentData.id}
      title={componentData.label}
      article={componentData.article.data}
      isAlignLeft={componentData.isAlignLeft}
    />
  )
}

export default ArticleLeftRightSection
